import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-wem-schedule-requests-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfWemScheduleRequestsIconProps extends SvgIconProps {}

/**
 * Component used to render WEM Schedule Requests tab Icon
 * @example
 */
export function CcfWemScheduleRequestsIcon(
  props: CcfWemScheduleRequestsIconProps
) {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M17.5 2H14.5V1C14.5 0.5 14.1 0 13.5 0C12.9 0 12.5 0.5 12.5 1V2H7.5V1C7.5 0.5 7.1 0 6.5 0C5.9 0 5.5 0.5 5.5 1V2H2.5C1.4 2 0.5 2.9 0.5 4V18C0.5 19.1 1.4 20 2.5 20H17.5C18.6 20 19.5 19.1 19.5 18V4C19.5 2.9 18.6 2 17.5 2ZM17.5 18H2.5V4H5.5V5C5.5 5.5 5.9 6 6.5 6C7.1 6 7.5 5.5 7.5 5V4H12.5V5C12.5 5.5 12.9 6 13.5 6C14.1 6 14.5 5.5 14.5 5V4H17.5V18Z"
        fill="#7D3CC8"
      />
      <path
        d="M10.5 8.5C10.5 9 10.9 9.5 11.3 9.5H15.6C16.1 9.5 16.4 9 16.4 8.5C16.4 8 16 7.5 15.6 7.5H11.3C10.9 7.5 10.5 8 10.5 8.5Z"
        fill="#7D3CC8"
      />
      <path
        d="M7.9 6.7L6 8.6L5.1 7.8C4.8 7.5 4.3 7.5 4 7.8C3.9 7.9 3.8 8.1 3.8 8.3C3.8 8.5 3.9 8.7 4 8.9L5.4 10.3C5.5 10.4 5.7 10.5 5.9 10.5C6.1 10.5 6.3 10.4 6.5 10.3L9 7.8C9.3 7.5 9.3 7 9 6.7C8.7 6.4 8.2 6.4 7.9 6.7Z"
        fill="#7D3CC8"
      />
      <path
        d="M15.7 13.5H11.4C10.9 13.5 10.6 14 10.6 14.5C10.6 15 11 15.5 11.4 15.5H15.7C16.2 15.5 16.5 15 16.5 14.5C16.5 14 16.1 13.5 15.7 13.5Z"
        fill="#7D3CC8"
      />
      <path
        d="M8.6 11.9C8.2 11.5 7.6 11.5 7.2 11.9L6.5 12.6L5.8 11.9C5.4 11.5 4.8 11.5 4.4 11.9C4 12.3 4 12.9 4.4 13.3L5.1 14L4.4 14.7C4 15.1 4 15.7 4.4 16.1C4.6 16.3 4.9 16.4 5.1 16.4C5.3 16.4 5.6 16.3 5.8 16.1L6.5 15.4L7.2 16.1C7.4 16.3 7.7 16.4 7.9 16.4C8.1 16.4 8.4 16.3 8.6 16.1C9 15.7 9 15.1 8.6 14.7L7.9 14L8.6 13.3C9 12.9 9 12.3 8.6 11.9Z"
        fill="#7D3CC8"
      />
    </SvgIcon>
  );
}

export default CcfWemScheduleRequestsIcon;
